module.exports = __webpack_public_path__ + "static/media/signage-industrial-img36.224d7577.jpg";